/**
 *
 */
import { isBlackFridayIntent } from '@shared/types/types.ts';
import type { SearchContext } from '@shared/types/types.ts';
import type { TileListPageFetcher } from '@tilelist/application/ports/TileListPageFetcher.ts';
import type { VariationLoader } from '@tilelist/application/ports/VariationLoader.ts';
import { toProductItem } from '@tilelist/domain/composition/RankedPositioning.ts';
import type { BlackFridaySliderItem } from '@tilelist/domain/composition/TileListitem.ts';
import {
    BLACK_FRIDAY_SLIDER_MIN_PRODUCTS,
    toBlackFridayQuery,
    toBlackFridaySliderItem,
} from '@tilelist/domain/feature-visibility/BlackFridaySlider.ts';

const COLLAPSED: BlackFridaySliderItem = { type: 'BlackFridaySlider', state: 'collapsed' };

export class BlackFridaySliderLoader {
    constructor(
        private readonly pageFetcher: TileListPageFetcher,
        private readonly variationLoader: Pick<VariationLoader, 'loadBestVariationsForFirstNProducts'>,
    ) {}

    /*                                                                                           */
    async load(searchContext: SearchContext): Promise<BlackFridaySliderItem> {
        const query = toBlackFridayQuery(searchContext);
        const result = await this.pageFetcher.getProducts(query);
        if (result.state === 'error') {
            return COLLAPSED;
        }

        const products = result.payload.intents.find(isBlackFridayIntent)?.products ?? [];
        if (products.length < BLACK_FRIDAY_SLIDER_MIN_PRODUCTS) {
            return COLLAPSED;
        }

        const items = products.map((product, index) =>
            toProductItem({ product, interleavedIndex: index, startingOffset: 0, originPosition: index }),
        );
        try {
            const enriched = await this.variationLoader.loadBestVariationsForFirstNProducts(items, items.length);
            return toBlackFridaySliderItem(enriched);
        } catch {
            return COLLAPSED;
        }
    }
}
